export default "__VITE_ASSET__CguOsSh$__"